<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-10 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2"><h2>Rates Settings</h2></div>
                          <div class="card-body text-center">

                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Name</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Rate (%)/Value</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Updated At</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in discounts" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td v-if="data.name==='mpesa'">
                        Safaricom Airtime to Mpesa rate.
                      </td>
                      <td v-else-if="data.name==='airtel_mpesa'">
                        <i class="text-danger">Airtel</i> Airtime to Mpesa rate.
                      </td>
                      <td v-else-if="data.name==='bonga'">
                        Bonga to Mpesa rate.
                      </td>
                      <td v-else-if="data.name==='airtime'">
                        Safaricom Airtime purchase rate.
                      </td>
                      <td v-else-if="data.name==='sending_no'">
                        Number to sambaza <i class="text-success">Safaricom</i> airtime
                      </td>
                       <td v-else-if="data.name==='receiving_no'">
                        Number to receive <i class="text-success">Safaricom</i> airtime and trigger B2C.
                      </td>
                      <td v-else-if="data.name==='airtel_receiver_no'">
                        Number to receive <i class="text-danger">Airtel</i> airtime and trigger B2C.
                      </td>
                      <td v-else>
                        {{data.name}}
                      </td>
                      <td v-if="data.name==='receiving_no'">
                        {{data.rate}}   <a href="#" v-on:click="showModal(data.id,data.rate,data.name)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td v-else-if="data.name==='airtel_receiver_no'">
                        {{data.rate}}   <a href="#" v-on:click="showModal(data.id,data.rate,data.name)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td v-else-if="data.name==='sending_no'">
                        {{data.rate}}
                      </td>
                      <td v-else>
                        {{data.rate}} %  <a href="#" v-on:click="showModal(data.id,data.rate,data.name)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td >
                       {{filerDate(data.updated_at)}}
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>

                          </div>
                        </div>




                        </div>
                        </div>

  <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Update the percentage/data rate for {{message.name}}</h6>
         <div class="form-group">
                    <label class="form-label">Rate/Number</label>
                    <input type="text" v-model="message.rate" class="form-control" required>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="updateRates()">Save changes</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            discounts:[],
            message:{id:'',name:'',rate:''}

            }
        },
        created(){
              this.getDiscount();
        },
        methods: {
          showModal(id,rate,name){
            this.message.rate=rate;
            this.message.id=id;
            this.message.name=name
             $('#edit').modal('show');
          },
          updateRates(){
            $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/updateRates`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getDiscount();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
            getDiscount(){
                let uri =`/api/auth/getDiscounts`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {

                   this.discounts=response.data;
                }).catch(error => {

                   if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },


            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
